<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="['Conta Corrente', 'Ano Movimentação', 'Mês Movimentação', 'Data Movimentação', 'Natureza', 'Cod. Tipo Lançamento', 'Canal', 'Classificação Lançamento', 'Tipo Lançamento', 'Valor Lançamento Crédito', 'Valor Lançamento Débito', 'Valor Lançamento Total']"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.contaCorrente ? parseInt(obj.contaCorrente).toString() : ''"  />
        <TableColumn :IsText="true" :status="1" :value="parseInt(obj.anoMovimento).toString()" />
        <TableColumn :IsText="true" :status="1" :value="obj.mesMovimento" />
        <TableColumn :IsText="true" :status="1" :value="formatDate(obj.dataMovimento)" />
        <TableColumn :IsText="true" :status="1" :value="obj.naturezaOperacao" />
        <TableColumn :IsText="true" :status="1" :value="parseInt(obj.codigoTipoLancamento).toString()" />
        <TableColumn :IsText="true" :status="1" :value="obj.canal" />
        <TableColumn :IsText="true" :status="1" :value="obj.classificacaoLancamento" />
        <TableColumn :IsText="true" :status="1" :value="obj.tipoLancamento" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorLancamentoCredito ? formatValue(obj.valorLancamentoCredito) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorLancamentoDebito ? formatValue(obj.valorLancamentoDebito) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.valorLancamentoTotal ? formatValue(obj.valorLancamentoTotal) : 'R$ 0,00'" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import DailyMovementRepository from '@/shared/http/repositories/business/dailyaccountmovement.js'

export default {
  name: 'DailyMovement',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadDailyMovement(this.document)
      }
    },
    onLoadDailyMovement (document) {
      loading.push()
      this.document = document
      DailyMovementRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/dailymovement.vue